import { CSVTableRowProps } from 'types';
import { Select } from './styles';
import Checkbox from 'components/ui/Checkbox';

const ScalerRow = ({ rowIndex, columnLabels, isEditMode, values, useFormReturn }: CSVTableRowProps) => {
  const { register, watch } = useFormReturn;
  const scaler = watch('scaler');

  if (isEditMode) {
    return (
      <tr>
        <th>스케일러</th>
        <td>
          <Select {...register('scaler')}>
            <option value="none">미사용</option>
            <option value="minmax">MinMax</option>
            <option value="standard">Standard</option>
            <option value="normalizer">Normalizer</option>
            <option value="robust">Robust</option>
          </Select>
        </td>
        {columnLabels.map((label, i) => (
          <td key={`col/${label}/row/${rowIndex}/edit`}>
            {values?.[i] !== undefined && (
              <>
                {scaler === 'none' ? (
                  <span>미사용</span>
                ) : (
                  <Checkbox id={`scaler/${i}`} {...register(`scalerColumns.${i}`)} />
                )}
              </>
            )}
          </td>
        ))}
      </tr>
    );
  }

  return (
    <tr>
      <th>{rowIndex}</th>
      {columnLabels.map((label) => (
        <td key={`col/${label}/row/${rowIndex}`}></td>
      ))}
    </tr>
  );
};

export default ScalerRow;
